import { CouponApi } from '../../generated/api';
import configuration from './configuration';

export default new CouponApi(configuration);
